const isColorObject = color => typeof color !== 'string' && color.main !== undefined;
const isColorStandardObject = color => typeof color !== 'string' && color.main !== undefined && color.ultraLight !== undefined && color.dark !== undefined;
const isColorGrayObject = color => typeof color !== 'string' && !!color[900];

export { isColorGrayObject, isColorObject, isColorStandardObject };
//# sourceMappingURL=theme.js.map
